module.exports = __webpack_public_path__ + "img/duels-coming-soon.5f133888.png";